import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import reducers from './reducers';
import { getAuthInLocalStorage } from '../utils/localStorage';

const middleware = [logger, thunk];

let INITIAL_STATE = {};

const auth = getAuthInLocalStorage();
if (auth) {
  INITIAL_STATE = {
    auth: {
      error: '',
      expire: auth.expire,
      isAdmin: auth.isAdmin,
      token: auth.token,
      qlikToken: auth.qlikToken,
    },
    customer: auth.customer,
    sport: auth.sport,
    user: auth.user,
  };
}

const store = createStore(
  reducers,
  INITIAL_STATE,
  composeWithDevTools(applyMiddleware(...middleware)),
);

export default store;
